import React from 'react';
import { ContainerWrapper } from './container.style';

const Container = ({ children, width, ...props }) => {
  return <ContainerWrapper width={width}>{children}</ContainerWrapper>;
};

export default Container;
